import { VisibilityState } from '../stores/visibility/visibilityReducer';

export const copyBlades = (Visibility: VisibilityState): VisibilityState => {
  const visibility: VisibilityState = {};

  Object.keys(Visibility).forEach((bladeName: string) => {
    visibility[bladeName] = { ...Visibility[bladeName] };
  });

  return visibility;
};

/**
 * Return a list of blades that are different in the two blade lists
 *
 * @param v1
 * @param v2
 */
export const compareBladeObjects = (v1: VisibilityState, v2: VisibilityState): VisibilityState => {
  const updatedBlades: VisibilityState = {};

  Object.keys(v1).forEach((bladeName: string) => {
    if (
      v1[bladeName].display !== v2[bladeName].display
      || v1[bladeName].required !== v2[bladeName].required
      || v1[bladeName].hasFocus !== v2[bladeName].hasFocus
    ) {
      updatedBlades[bladeName] = v2[bladeName];
    }
  });

  return updatedBlades;
};
